module.exports = __webpack_public_path__ + "img/file-earmark-x-fill.89748385.svg";